<template>
  <tr>
    <td>
      {{ $dayjs(data.date).format('L - ddd') }}
    </td>
    <td
      v-for="variable in variables.slice(1)"
      :key="variable.id"
    >
      <table-bar-value
        :value="data.stats[getVariableKey(variable.value)]"
        :max="colorMaxValues[getVariableKey(variable.value)] ? colorMaxValues[getVariableKey(variable.value)] : maxValues[getVariableKey(variable.value)]"
        :color="colorMaxValues[getVariableKey(variable.value)] ? getColorFromValue(data.stats[getVariableKey(variable.value)], colorMaxValues[getVariableKey(variable.value)], variable.reverse) : 'grey lighten-2'"
      >
        {{ data.stats[getVariableKey(variable.value)] }}
      </table-bar-value>
    </td>
  </tr>
</template>

<script>
import TableBarValue from '@/components/helpers/TableBarValue'
import { getColorForValue, getColorForValueWithDefinition } from '@/utils/helpers'
import { acwrColorsDefinition } from '@/data/models/Stats'
import { maxValuesPerformanceIndividual } from '@/data/models/TableHeader'

export default {
  name: 'PlayerTrainingLoadTableRow',
  components: { TableBarValue },
  props: {
    data: {
      type: Object,
      required: true
    },
    maxValues: {
      type: Object,
      default: () => ({})
    },
    player: {
      type: Object,
      default: () => ({})
    },
    aggregation: {
      type: String,
      required: true
    },
    variables: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    colorMaxValues: maxValuesPerformanceIndividual
  }),
  methods: {
    getAcwrColorFromValue(value) {
      return getColorForValueWithDefinition(value, acwrColorsDefinition)
    },
    getVariableKey(variable) {
      return variable + this.aggregation
    },
    getColorFromValue(value, max, reverse = false) {
      return getColorForValue(value, max, reverse)
    }
  }
}
</script>
